// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"88":"component---src-pages-sobre-js","293":"component---src-pages-index-js","654":"component---src-pages-fotos-js"}[chunkId] + "-" + {"88":"e094161ea27da121bad0","293":"8b7ec731e32b6298ee4c","654":"161824e227681f674866"}[chunkId] + ".js";
};